import { z } from "zod";
import { MunicipalitySchema } from "../../models/municipality.schema";
import { PaginationSchema } from "./pagination.schema";

export const MunicipalityControllerResponseSchema = {
  getMunicipalities: z.object({
    data: MunicipalitySchema.array(),
    pagination: PaginationSchema,
  }),

  getStates: z.object({
    data: z.string().array(),
  }),

  getMunicipalitiesForState: z.object({
    data: MunicipalitySchema.array(),
    pagination: PaginationSchema,
  }),

  getMunicipality: z.object({
    data: MunicipalitySchema.extend({
      rate: z.number(),
      population_based_rate: z.number(),
    }).optional(),
  }),
};
